// extracted by mini-css-extract-plugin
export default {"container":"AttachmentListWrapper__container___FZAym","skeleton-loading":"AttachmentListWrapper__skeleton-loading___nQCnd"};